<template>
    <div>
        <div v-if="selected_bank">
            <h3 class="mb-0">Refinance Details</h3>
            <b-form role="form" class="mt-4">
                <b-row>
                    <b-col md="8" cols="12">
                        <b-form-group label="Bank Selected">
                            <el-image style="height: 20px;" :src="selected_bank.bank_image_url" fit="contain">
                                <template #error>
                                    <div class="image-slot">
                                        <span class="d-inline-block text-truncate" style="max-width: 90px;">{{ selected_bank.bank_name }}</span>
                                    </div>
                                </template>
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Types of Property Sales">
                            <b-form-input
                                v-model="form.property_sales"
                                type="text"
                                disabled
                                ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Project Name">
                            <b-form-input
                            v-model="form.project_name"
                            type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Latest Market Value">
                            <CurrencyInput
                                v-model="form.remortgage_amount"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Loan Margin (%)">
                            <b-form-input
                            v-model="form.loan_margin"
                            type="number"
                            step="0.01"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Loan Amount">
                            <CurrencyInput
                                v-model="form.loan_amount"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Interest Rate (%)">
                            <b-form-input
                            v-model="form.interest_per_annum"
                            type="text"
                            maxlength=5
                            @keydown="preventNonNumericInput"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Tenure Year">
                            <b-form-input
                            v-model="form.tenure_year"
                            type="text"
                            maxlength=2
                            @keydown="preventNonNumericInput"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Installment (RM)">
                            <CurrencyInput
                                v-model="installment"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>
    
                    <b-col md="8" cols="12">
                        <b-form-group label="Bank Outstanding">
                            <CurrencyInput
                                v-model="form.bank_outstanding" disabled
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="8" cols="12">
                        <b-form-group label="Cashout">
                            <CurrencyInput
                                v-model="form.cashout_amount" disabled
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                    </b-col>
    
                    <b-col cols="12" v-if="checkAppCode('sas')">
                        <h3 class="mb-4">Arrangement Fee</h3>
                    </b-col>
        
                    <b-col md="8" cols="10" v-if="checkAppCode('sas')">
                        <b-form-group label="Arrangement Fee Amount">
                            <b-form-input
                            v-model="form.arrangement_fee"
                            type="number"
                            step="0.01"
                                ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12" v-if="checkAppCode('sas')">
                        <b-form-group label="Arrangement Fee SST">
                            <b-form-radio-group
                                v-model="form.arrangement_fee_sst"
                                :options="SST_OPTIONS"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>
    
                    <b-col md="8" cols="12" v-if="checkAppCode('sas')">
                            <b-form-group label="Total Arrangement Fee (RM)">
                            <b-form-input
                            v-model="form.arrangement_fee_amount"
                            type="text"
                            required
                            disabled
                            placeholder="0.00"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
    
                    <b-col md="8" cols="12">
                        <b-button block variant="primary" class="my-5" @click.prevent="saveRefinance">
                            <span v-if="!existing_refinance">Proceed</span>
                            <span v-else>Add</span>
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <p class="text-center" v-else>Please select a bank.</p>
    </div>
</template>
<script>
import { Image } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput' 
import { mapActions, mapState } from 'pinia'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import { useProductStore } from '@/stores/productStore'
import {
  calculateInstallment, 
  calculateLoanAmount,
} from '@/assets/js/calculator.js'
import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import {SST_OPTIONS} from '@/assets/js/options.js'

export default {
    components: {
        [Image.name]: Image,
        CurrencyInput,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data() {
        return {
            existing_refinance: null,
            selected_bank: null,
            form: {
                property_sales: 'refinance',
                remortgage_amount: 500000,
                project_name: null,
                loan_margin: 90,
                loan_amount: 450000,
                installment: 0,
                interest_per_annum: '',
                bank_outstanding: 200000,
                cashout_amount: 250000,
                interest_rate: 3.95,
                tenure_year: 25,
                arrangement_fee: 0,
                arrangement_fee_any_amount: '',
                arrangement_fee_amount: 0,
                arrangement_fee_sst: 0,
            },
            SST_OPTIONS: SST_OPTIONS,
        }
    },
    watch: {
        '$route.query.product_id':{
            handler(newVal){
                if(this.current_product_type === 'refinance'){
                    const productData = this.refinance_draft_products.find((item) => item.prod_id == newVal)
                    if(productData){
                        this.existing_refinance = productData
                        this.form.project_name = productData.product_detail.prod_ref_project_name
                        if(productData.product_banks.length > 0){
                            this.form.spa_price = productData.product_banks[0].prod_bnk_spa_amount
                        }
                    }
                }
            },
            immediate: true
        },
        'current_product_data':{
            handler(newVal){
                if(this.current_product_type === 'refinance'){
                    if(newVal.hasOwnProperty('banks')){
                        this.selected_bank = newVal.banks[0]
                        this.form.interest_per_annum = newVal.banks[0].bank_refinance_interest_rate
                        this.form.installment = newVal.banks[0].bank_refinance_instalment
                        this.form.tenure_year = newVal.banks[0].bank_loan_tenure_year
                        this.form.loan_amount = newVal.banks[0].bank_refinance_loan_amount
                        this.form.loan_margin = newVal.banks[0].bank_refinance_loan_margin
                        this.form.cashout_amount = newVal.banks[0].bank_refinance_cashout_amount
                        this.form.remortgage_amount = this.refinance_details.remortgage_amount
                        this.form.bank_outstanding = this.refinance_details.bank_outstanding
                    }
                }
            },
        },
        'form':{
            handler(newVal){
                if(newVal){ 
                    let sst_fee = parseFloat(this.form.arrangement_fee) * parseFloat(this.form.arrangement_fee_sst) / 100
                    //set total arragement fee
                    let arrangement_fee_amount = parseFloat(this.form.arrangement_fee) + parseFloat(sst_fee)
                    if(isNaN(arrangement_fee_amount)){
                        this.form.arrangement_fee_amount = 0
                    }else{
                        this.form.arrangement_fee_amount = arrangement_fee_amount
                    }
                }
            },
            deep: true,
        },
        'form.remortgage_amount': {
            handler(newVal){
                if(newVal)
                {
                    this.form.loan_amount = calculateLoanAmount(newVal, this.form.loan_margin)
                }
            },
            deep: true,
        },
        'form.loan_margin': {
            handler(newVal){
                if(newVal)
                {
                    this.form.loan_amount = calculateLoanAmount(this.form.remortgage_amount, newVal)
                }
            },
            deep:true,
        },
        'form.loan_amount': {
            handler(newVal){
                if(newVal)
                {
                    // this.form.installment = calculateInstallment(this.form.loan_amount, this.form.interest_rate, this.form.tenure_year)
                    this.form.cashout_amount = newVal - this.form.bank_outstanding
                }
            },
            deep:true,
        }
    },
    computed: {
        ...mapState(useProductStore, ['current_product_data', 'current_product_type', 'refinance_details', 'refinance_draft_products']),
        installment:{
            get(){
                return calculateInstallment(this.form.loan_amount, this.form.interest_per_annum, this.form.tenure_year)
            },
            set(val){
                this.form.installment = val
            }
        }
    },
    methods: {
        ...mapActions(useProductStore, ['createRefinanceProduct', 'getCustomerProducts']),
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        async saveRefinance() {
            const refinance = {
                refinance_remortgage_amount: this.form.remortgage_amount,
                refinance_project_name: this.form.project_name,
                refinance_loan_amount: this.form.loan_amount,
                refinance_loan_margin: this.form.loan_margin,
                refinance_interest_rate: this.form.interest_per_annum,
                refinance_tenure_year: this.form.tenure_year,
                refinance_installment: this.form.installment,
                refinance_bank_outstanding: this.form.bank_outstanding,
                refinance_cashout_amount: this.form.cashout_amount,
                refinance_arragement_fee: this.form.arrangement_fee,
                refinance_arragement_sst_fee: this.form.arrangement_fee_sst,
                refinance_arragement_amount: this.form.arrangement_fee_amount,
            }

            if(this.existing_refinance){
                try{
                    await this.addRefinanceAdditionalBank(refinance)
                    this.notifySuccess('<b>Bank </b> - Successfully Added.')
                    this.resetField()
                    // remove product id once added bank
                    const currentQuery = { ...this.$route.query };
                    delete currentQuery.product_id;
                    this.$router.replace({query: currentQuery,},() => {})

                    solutionEventBus.$emit('show-refinancing-summary')
                }catch(e){
                    this.errorFunction(null, e)
                }
            } else {
                useProductStore().$patch((state) => {
                    state.current_product_data = { 
                        ...state.current_product_data, 
                        refinance: refinance
                    }
                })
        
                try{
                    await this.createRefinanceProduct()
                    this.notifySuccess('<b>Draft </b> - Successfully Created.')
                    this.selected_bank = null
                    solutionEventBus.$emit('show-refinancing-summary')
                }catch(e){
                    this.errorFunction(e, 'error create')
                }
            }
        },
        resetField(){
            this.selected_bank = null
            this.existing_refinance = null
            this.form.remortgage_amount = null
            this.form.project_name = ''
            this.form.loan_margin = 90
            this.form.loan_amount = ''
            this.form.tenure_year = ''
            this.form.installment = ''
            this.form.interest_per_annum = ''
            this.form.bank_outstanding = ''
            this.form.cashout_amount = ''
            this.form.arrangement_fee = 0
            this.form.arrangement_fee_any_amount = 0
            this.form.arrangement_fee_amount = 0
            this.form.arrangement_fee_sst = 0
        },
        async addRefinanceAdditionalBank(refinance){
            let bankData = {
                "prod_bnk_prod_id": this.existing_refinance.prod_id,
                "prod_bnk_name": this.selected_bank.bank_name,
                "prod_bnk_logo_url": this.selected_bank.bank_image_url,
                "prod_bnk_provider_id": null,
                "prod_bnk_stage_status":"Pending Submission",
                "prod_bnk_loan_amount": refinance.refinance_loan_amount,
                "prod_bnk_interest": refinance.refinance_interest_rate,
                "prod_bnk_margin": refinance.refinance_loan_margin,
                "prod_bnk_tenure": refinance.refinance_tenure_year,
                "prod_bnk_gross_cashback": null,
                "prod_bnk_installment": refinance.refinance_installment,
                "prod_bnk_code": this.selected_bank.bank_code,
                "prod_bnk_agreement_rate": this.form.arrangement_fee,
                "prod_bnk_agreement_rate_sst": this.form.arrangement_fee_sst,
                "prod_bnk_agreement_fees": this.form.arrangement_fee_amount,
            }
            
            const res = await axios.post(services.product + 'product-bank', bankData, {headers: getHeader()})
            this.getCustomerProducts(this.existing_refinance.prod_customer_id)
        }
    }
}
</script>